import { dateColumn, primaryRelationshipColumn, textColumn } from "./columnHelpers";

export const involvementsRelationship = {
    collapsible: false,
    title: 'Involvements',
    tint: 'default',
    type: 'involvements',
};

export const involvementsRelationshipEdit = {
    collapsible: false,
    title: 'Involvements',
    tint: 'default',
    type: 'table',
    columns: [
        primaryRelationshipColumn({
            label: 'Involvement',
            endpoint: 'involvements',
            groupBy: (option) => option.category_name,
        }),
        textColumn({label: 'Data', width: '30%', column: 'pivot.date'}),
        textColumn({label: 'Notes', width: '30%', column: 'pivot.notes'}),
    ],
};
